// Brand lockups of the payment method on /status (Figma 30679-18302 / 30882-27753): icon + name,
// exported without background so they sit on the classic card's beige block and on the commitment
// card's white one alike. Keys are med-billing-engine `PaymentMethodType` values; methods without a
// drawn lockup (ideal, pix, pix_automatico, unknown) map to nothing.
import methodCard from '@/assets/payment/methods/card.svg'
import methodApplePay from '@/assets/payment/methods/apple-pay.svg'
import methodGooglePay from '@/assets/payment/methods/google-pay.svg'
import methodPaypal from '@/assets/payment/methods/paypal.svg'
import methodAffirm from '@/assets/payment/methods/affirm.svg'
import methodKlarna from '@/assets/payment/methods/klarna.svg'

export interface PaymentMethodLockup {
	src: string
	alt: string
}

const LOCKUPS: Record<string, PaymentMethodLockup> = {
	payment_card: { src: methodCard, alt: 'Card' },
	apple_pay: { src: methodApplePay, alt: 'Apple Pay' },
	google_pay: { src: methodGooglePay, alt: 'Google Pay' },
	paypal: { src: methodPaypal, alt: 'PayPal' },
	affirm: { src: methodAffirm, alt: 'Affirm' },
	klarna: { src: methodKlarna, alt: 'Klarna' },
}

export function paymentMethodLockup(method: string | null | undefined): PaymentMethodLockup | null {
	return (method && LOCKUPS[method]) || null
}
